// extracted by mini-css-extract-plugin
module.exports = {"offline-instruction":"VI8Mw","offlineInstruction":"VI8Mw"};